import FileUpload from "@mui/icons-material/FileUploadRounded";
import * as Styles from "../FileDropContainer.styles";

export default function FileDropContainerInfoCard() {
  return (
    <Styles.CardContainer>
      <Styles.CardContent>
        <FileUpload />
        <h2>Solte aqui o arquivo XML da nota fiscal</h2>
      </Styles.CardContent>
    </Styles.CardContainer>
  );
}
